import {Component} from "react";

const React = require('react'),

    translate = require('../../translate'),
    FormModal = require('./FormModal');


class ForceOccupancyForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            state: 'closed',
            occupancy: '0',
            closeModal: this.closeModal.bind(this)
        };
    }

    closeModal = () => {
        this.setState({state: 'closed'});
    }

    render() {

        let { language, operationId, token } = this.props;
        let { state, occupancy, closeModal } = this.state;

        let title = translate(language, 'Set current occupancy');

        if (state === 'form') {
            let inputTitle = translate(language, 'Number of persons in store');
            const onChange = event => this.setState({occupancy: event.target.value});
            const submit = () => {
                let data = {
                    operation_id: operationId,
                    occupancy: parseInt(occupancy),
                    happened_at: new Date().toISOString()
                }
                fetch('/occupancy/forced', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    },
                    body: JSON.stringify(data)
                }).then(response => this.setState({state: 'submitted'}));
            };

            return <FormModal title={title} language={language} closeModal={closeModal}>
                <div className="content text-left">
                    <div className="form-group">
                        <label className="form-label" htmlFor="input-occupancy">{inputTitle}</label>
                        <input className="form-input" type="number" step="1" pattern="\d+" id="input-occupancy"
                               value={occupancy} onChange={onChange} placeholder={inputTitle}/>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className='btn btn-primary' onClick={submit}>{translate(language, 'Submit')}</button>
                    <button className='btn btn-link' onClick={closeModal}>{translate(language, 'Cancel')}</button>
                </div>
            </FormModal>;
        } else if (state === 'submitted') {
            return <FormModal language={language} closeModal={closeModal}>
                <div className="content text-left">
                    {translate(language, 'Occupancy was set to {0}.', [occupancy])}
                </div>
                <div className="modal-footer">
                    <button className='btn btn-primary' onClick={closeModal}>{translate(language, 'Close')}</button>
                </div>
            </FormModal>;
        } else {
            return <button onClick={() => this.setState({state: 'form'})} className='btn btn-sm btn-link'>{title}</button>;
        }
    }
}

export default ForceOccupancyForm;